import * as React from "react";

import { cn } from "./utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex min-h-20 w-full resize-none rounded-[var(--radius-md)] border border-[var(--color-border-default)] bg-[var(--color-bg-sunken)] px-3 py-2 text-sm leading-6 text-[var(--color-text-primary)] transition-[border-color,outline-color,background-color] duration-[var(--duration-fast)] ease-[var(--ease-default)] outline-none placeholder:text-[var(--color-text-tertiary)] focus-visible:border-[var(--color-border-strong)] focus-visible:outline-2 focus-visible:outline-[var(--color-brand)] focus-visible:outline-offset-2 aria-invalid:border-[var(--color-danger)] disabled:cursor-not-allowed disabled:opacity-40",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
